import { useEffect, useRef, useState } from "react";

import { motion, animate, useInView } from "framer-motion";
import {
  Activity,
  Smartphone,
  Users,
  
} from "lucide-react";

import "../Styles/TrustBy.css";


import api from '../Component/Api';

const professions = [
  "Barbers",
  "DJs",
  "MCs",
  "Content Creators",
  "Photographers",
  "Fitness Coaches",
  "Makeup Artists",
  "Hair Stylists",
  "Business Owners",
  "Freelancers",
  "Entrepreneurs",
  "Creators",
];

const TapCounter = () => {

const items = [...professions, ...professions];

  const [totalTaps, setTotalTaps] = useState(34788);
  const [count, setCount] = useState(0);

  const counterRef = useRef(null);
  const isInView = useInView(counterRef, {
    once: true,
    margin: "-100px",
  });

  


    useEffect(() => {
    const getTotalTaps = async () => {
      try {
        const response = await api.get('/total-lifetime-scans'
        );

        if (response.data.success) {
          setTotalTaps(response.data.totalScans);
        }
      } catch (error) {
        console.error("Failed to fetch total taps:", error);
      }
    };

    getTotalTaps();
   
  }, []);

  // Counter animation
  useEffect(() => {
    if (!isInView) return;

    const controls = animate(0, totalTaps, {
      duration: 2.5,
      ease: "easeOut",
      onUpdate(value) {
        setCount(Math.floor(value));
      },
    });

    return () => controls.stop();
  }, [isInView, totalTaps]);

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <section style={styles.container}>
      {/* Heading */}
      <motion.div
        style={styles.header}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
      >
        <p style={styles.eyebrow}>LIVE CLUSTERCLEAR NETWORK</p>

        <h2 style={styles.title}>
          Every tap creates
          <br />
          <span style={styles.titleLight}>a new connection.</span>
        </h2>
      </motion.div>

      {/* Counter */}
      <motion.div
        ref={counterRef}
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1],
        }}
        style={styles.counterWrapper}
      >
        <motion.div
          animate={{
            scale: [1, 1.15, 1],
            opacity: [0.2, 0.35, 0.2],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={styles.glow}
        />

        <p style={styles.counterLabel}>LIVE TOTAL TAPS</p>

        <h1 style={styles.counter}>
          {(12480 + parseInt(count.toLocaleString()))}+
        </h1>

        <p style={styles.counterText}>
          People have connected using ClusterClear wristbands.
        </p>
      </motion.div>

      {/* Analytics Cards */}
      <div style={styles.grid}>
        {[
          {
            icon: <Activity size={24} color="#6355FF" />,
            title: "Growing every day",
            text: "New taps are recorded across all ClusterClear users.",
          },
          {
            icon: <Smartphone size={24} color="#6355FF" />,
            title: "One simple tap",
            text: "Instagram, WhatsApp, TikTok and websites open instantly.",
          },
          {
            icon: <Users size={24} color="#6355FF" />,
            title: "Creators & businesses",
            text: "Barbers, creators, restaurants and professionals already use ClusterClear.",
          },
        ].map((card, index) => (
          <motion.div
            key={index}
            style={styles.card}
            initial={{ opacity: 0, y: 35 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              delay: index * 0.15,
              duration: 0.7,
            }}
            whileHover={{
              y: -8,
            }}
          >
            <div style={styles.icon}>{card.icon}</div>

            <h3 style={styles.cardTitle}>{card.title}</h3>

            <p style={styles.cardText}>{card.text}</p>
          </motion.div>
        ))}
      </div>

      {/* LIVE ACTIVITY TICKER */}
   <section style={styles.container}>
      
      {/* Heading */}
      <motion.div
        style={styles.header}
        initial={{ opacity: 0, y: 25 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        <p style={styles.eyebrow}>
          TRUSTED BY
        </p>

        <h2 style={styles.title}>
          Made for people that
          <br />
          <span style={styles.light}>Loves their business.</span>
        </h2>
      </motion.div>


      {/* Infinite ticker */}
      <div style={styles.tickerWrapper}>
        <div style={styles.ticker}>
          
          {items.map((profession, index) => (
            <div
              key={index}
              style={styles.item}
            >
              <span>{profession}</span>

              <span style={styles.dot}>
                •
              </span>
            </div>
          ))}

        </div>
      </div>

    </section>

  

      {/* Bottom Statement */}
      <motion.div
        style={styles.bottom}
        initial={{ opacity: 0, y: 25 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p style={styles.bottomLabel}>JOIN THE NETWORK</p>

        <h2 style={styles.bottomTitle}>
          Your next customer
          <br />
          is one tap away.
        </h2>
      </motion.div>
    </section>
  );
};

const styles = {
  container: {
    padding: "170px 20px",
    background: "#fff",
    color: "#111",
    overflow: "hidden",
  },

  header: {
    textAlign: "center",
    marginBottom: "70px",
  },

  eyebrow: {
    color: "#7b7b7b",
    letterSpacing: ".18em",
    fontSize: "12px",
    fontWeight: "600",
  },

  title: {
    fontSize: "clamp(3rem,6vw,5.5rem)",
    lineHeight: 1,
    letterSpacing: "-.06em",
    margin: "20px 0",
  },

  titleLight: {
    color: "#777",
    fontWeight: 600,
  },

  counterWrapper: {
    position: "relative",
    textAlign: "center",
    marginBottom: "90px",
  },

  glow: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%,-50%)",
    width: 260,
    height: 260,
    borderRadius: "50%",
    background: "rgba(99,85,255,.14)",
    filter: "blur(60px)",
    zIndex: 0,
  },

  counterLabel: {
    color: "#6355FF",
    letterSpacing: ".15em",
    fontSize: "12px",
    fontWeight: 700,
    position: "relative",
    zIndex: 2,
  },

  counter: {
    fontSize: "clamp(4.5rem,10vw,8rem)",
    margin: "12px 0",
    letterSpacing: "-.08em",
    position: "relative",
    zIndex: 2,
  },

  counterText: {
    color: "#666",
    fontSize: "1.05rem",
    position: "relative",
    zIndex: 2,
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
    gap: 24,
    maxWidth: 1100,
    margin: "0 auto 120px",
  },

  card: {
    background: "#FAFAFA",
    border: "1px solid #EFEFEF",
    borderRadius: 28,
    padding: 32,
    transition: ".3s",
  },

  icon: {
    width: 52,
    height: 52,
    borderRadius: "50%",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,.05)",
    marginBottom: 22,
  },

  cardTitle: {
    margin: 0,
    marginBottom: 12,
    fontSize: "1.3rem",
  },

  cardText: {
    margin: 0,
    color: "#666",
    lineHeight: 1.7,
  },

  activitySection: {
    marginTop: 60,
    marginBottom: 140,
  },

  activityHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    marginBottom: 28,
    fontWeight: 600,
    fontSize: 13,
    letterSpacing: ".15em",
    color: "#666",
  },

  liveDot: {
    width: 8,
    height: 8,
    background: "#22C55E",
    borderRadius: "50%",
    boxShadow: "0 0 12px #22C55E",
  },

  marquee: {
    width: "100%",
    overflow: "hidden",
    position: "relative",
    maskImage:
      "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
    WebkitMaskImage:
      "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
  },

  marqueeTrack: {
    display: "flex",
    width: "max-content",
    animation: "scroll 28s linear infinite",
    gap: 18,
  },

  userCard: {
    minWidth: 320,
    background: "#fff",
    border: "1px solid #ECECEC",
    borderRadius: 18,
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    gap: 16,
    boxShadow: "0 10px 30px rgba(0,0,0,.04)",
  },

  avatar: {
    width: 46,
    height: 46,
    borderRadius: "50%",
    background: "#6355FF",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
  },

  userInfo: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    flex: 1,
    fontSize: 14,
    color: "#666",
  },

  platform: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    color: "#6355FF",
    fontWeight: 600,
    fontSize: 13,
  },

  bottom: {
    textAlign: "center",
  },

  bottomLabel: {
    color: "#777",
    fontSize: 12,
    letterSpacing: ".18em",
    marginBottom: 20,
  },

  bottomTitle: {
    fontSize: "clamp(2.8rem,5vw,4.8rem)",
    lineHeight: 1.05,
    letterSpacing: "-.05em",
    margin: 0,
  },


  light: {
    color: "#888",
    fontWeight: "600",
  },

  tickerWrapper: {
    width: "100%",
    overflow: "hidden",
    position: "relative",

    // Fade the edges
    maskImage:
      "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",

    WebkitMaskImage:
      "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
  },

  ticker: {
    display: "flex",
    width: "max-content",
    animation: "clusterClearTicker 35s linear infinite",
    willChange: "transform",
  },

  item: {
    display: "flex",
    alignItems: "center",
    gap: "45px",
    paddingRight: "45px",
    whiteSpace: "nowrap",
    fontSize: "clamp(1.2rem, 2vw, 1.7rem)",
    fontWeight: "500",
    color: "#555",
    letterSpacing: "-0.02em",
  },

  dot: {
    color: "#6355ff",
    fontSize: "20px",
  },
  
};

export default TapCounter;